import { render, staticRenderFns } from "./oportunidad-form.vue?vue&type=template&id=b2da6426&scoped=true"
import script from "./oportunidad-form.vue?vue&type=script&lang=js"
export * from "./oportunidad-form.vue?vue&type=script&lang=js"
import style0 from "./oportunidad-form.vue?vue&type=style&index=0&id=b2da6426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2da6426",
  null
  
)

export default component.exports